import ServiceExec from '@/common/utils/ServiceExec';
import { bizNotificationAPI } from '@/common/service/ApiList';
const { notifications, total_noti, detail_noti } = bizNotificationAPI;

export default {
  FETCH_LIST: async ({ state, commit, getters }) => {
    let { page, limit, storeNos } = state.condition;
    const { totalPage } = state.pageInfo;

    const condition = getters['getCondition'];

    if (page > totalPage) return;

    if (page === 1) limit = 20;
    const { status, data } = await ServiceExec.get(total_noti, {
      page,
      limit,
      storeNos
    });

    if (status === ServiceExec.status.OK) {
      const { list, pageInfo } = data;
      commit('setList', list);
      commit('setPageInfo', pageInfo);

      commit('setPage', condition.page + 1);
    }
  },

  getDetail: async ({ commit }, payload) => {
    const { status, data } = await ServiceExec.get(detail_noti(payload.pushNo));
    if (status === ServiceExec.status.OK) {
      commit('setDetail', data);
    }
  }
};
